const XLSX = require('xlsx');

//将行,列转换
function transformSheets(sheets) {
  var content = [];
  var content1 = [];
  var tmplist = [];
  for (let key in sheets) {
    //读出来的workbook数据很难读,转换为json格式,参考https://github.com/SheetJS/js-xlsx#utility-functions
    tmplist.push(XLSX.utils.sheet_to_json(sheets[key]).length);
    content1.push(XLSX.utils.sheet_to_json(sheets[key]));
  }
  var maxLength = Math.max.apply(Math, tmplist);
  //进行行列转换
  for (let y in [...Array(maxLength)]) {
    content.push([]);
    for (let x in [...Array(tmplist.length)]) {
      try {
        for (let z in content1[x][y]) {
          content[y].push(content1[x][y][z]);
        }
      } catch (error) {
        content[y].push(' ');
      }
    }
  }
  content.unshift([]);
  for (let key in sheets) {
    content[0].push(key);
  }
  return content;
}

export function getTime(date, format) {
  if (!date) return '-';
  if (!(date instanceof Date)) {
    if (typeof date === 'string') {
      if (date.indexOf('.') > -1) {
        // 有些日期接口返回带有.0。
        date = date.substring(0, date.indexOf('.'));
      }
      // 解决IOS上无法从dateStr parse 到Date类型问题
      date = date.replace(/-/g, '/');
    }
    date = new Date(date);
  }
  var paddNum = (num) => {
    num += '';
    return num.replace(/^(\d)$/, '0$1');
  };
  // 指定格式字符
  var cfg = {
    yyyy: date.getFullYear(), // 年 : 4位
    yy: date.getFullYear().toString().substring(2), // 年 : 2位
    M: date.getMonth() + 1, // 月 : 如果1位的时候不补0
    MM: paddNum(date.getMonth() + 1), // 月 : 如果1位的时候补0
    d: date.getDate(), // 日 : 如果1位的时候不补0=
    dd: paddNum(date.getDate()), // 日 : 如果1位的时候补0
    hh: paddNum(date.getHours()), // 时
    mm: paddNum(date.getMinutes()), // 分
    ss: paddNum(date.getSeconds()), // 秒
  };
  format || (format = 'yyyy-MM-dd hh:mm:ss');
  return format.replace(/([a-z])(\1)*/gi, (m) => {
    return cfg[m];
  });
}

// 节流
export function throttle(fun, delay) {
  let last, deferTimer
  return function(args) {
    const that = this
    const _args = arguments
    const now = +new Date()
    if (last && now < last + delay) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(function() {
        last = now
        fun.apply(that, _args)
      }, delay)
    } else {
      last = now
      fun.apply(that, _args)
    }
  }
}
// 防抖
export function debounce(fun, delay) {
  return function(args) {
    const that = this
    const _args = args
    clearTimeout(fun.id)
    fun.id = setTimeout(function() {
      fun.call(that, _args)
    }, delay)
  }
}
export { transformSheets as default };
